import { Service, inject } from '@angular/core'
import {
  GetManagedPaymentsResponse,
  GetUserPaymentsResponse,
  AcceptPaymentsBody,
  CancelPaymentsBody,
  CreatePaymentForUsersBody,
  DeleteEntityResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class PaymentApiService {
  private readonly api = inject(ApiService)

  getUserPayments(init?: RequestInit) {
    const url = this.api.createURL(`user/payments`)
    url.search = this.api.toQueryParams({})
    return this.api.protectedFetchJson<GetUserPaymentsResponse>(url, { ...init })
  }

  getPayments(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedPaymentsResponse>(`manage/entities/${entityId}/payments`, { ...init })
  }

  createPaymentForUsers(entityId: string, body: CreatePaymentForUsersBody, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedPaymentsResponse>(`manage/entities/${entityId}/payments`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deletePayment(entityId: string, paymentId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`manage/entities/${entityId}/payments/${paymentId}`, {
      method: 'DELETE',
      ...init,
    })
  }

  acceptPayments(entityId: string, body: AcceptPaymentsBody, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedPaymentsResponse>(`manage/entities/${entityId}/payments/accept`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  cancelPayments(entityId: string, body: CancelPaymentsBody, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedPaymentsResponse>(`manage/entities/${entityId}/payments/cancel`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
